import { PageContainer } from '../../components/Layout/PageContainer';
import { PageBreadcrumb } from '../../components/UI/PageBreadcrumb';
import { GraphQLTester } from '../../components/UI/GraphQLTester';
import { CustomButton } from '../../components/UI/CustomButton';
import { useToastContext } from '../../components/UI/ToastManager';

export function DashboardPage() {
  const { showInfo } = useToastContext();

  const testEditFunctionality = () => {
    showInfo('Test', 'Edit functionality test - check console for logs');
    console.log('Testing edit functionality...');
  };

  return (
    <PageContainer>
      <PageBreadcrumb items={['Home', 'Dashboard']} />
      <GraphQLTester />
      <div style={{ marginTop: '20px' }}>
        <CustomButton onClick={testEditFunctionality} visual="solid">
          Test Edit Functionality
        </CustomButton>
      </div>
    </PageContainer>
  );
}